import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BadgePoundSterling, ShieldCheck } from 'lucide-react';
import { FEE_CATEGORIES, formatFeePrice } from '../data/feesData';

const fee = (name) => FEE_CATEGORIES.flatMap((c) => c.items).find((i) => i.name === name);

// The three prices people look for first; the full list lives on /fees.
const ROWS = [
  { label: 'Initial Assessment', item: fee('Initial Assessment — Self Pay') },
  { label: 'Signature Jaw Massage', item: { duration: 60, price: 95 } },
  { label: 'NESA Neuromodulation', item: fee('NESA Neuromodulation — Self Pay') },
];

export default function FeesPreview() {
  return (
    <section className="fees-preview-section" aria-labelledby="fees-preview-title" data-testid="fees-preview">
      <div className="section-container">
        <Link to="/fees" className="fees-preview-card" data-testid="fees-preview-link">
          <div className="fees-preview-head">
            <span className="fees-preview-eyebrow"><BadgePoundSterling size={14} aria-hidden="true" /> Transparent Fees &amp; Insurance</span>
            <h2 id="fees-preview-title" className="fees-preview-title">Know the cost before you book</h2>
            <p className="fees-preview-body">
              Every self-pay price is published in full. Cigna, WPA, Bupa Global and Healix Health appointments are billed direct to your insurer.
            </p>
          </div>
          <ul className="fees-preview-list">
            {ROWS.map(({ label, item }) => (
              <li key={label} className="fees-preview-item" data-testid={`fees-preview-${label.toLowerCase().replace(/\s+/g, '-')}`}>
                <span className="fees-preview-name">{label}</span>
                <span className="fees-preview-meta">{item.duration} mins · <strong>£{formatFeePrice(item.price)}</strong></span>
              </li>
            ))}
          </ul>
          <span className="fees-preview-cta">
            <ShieldCheck size={16} aria-hidden="true" /> See all fees, packages &amp; insurance <ArrowRight size={16} aria-hidden="true" />
          </span>
        </Link>
      </div>
    </section>
  );
}
